// export const formFields = {
//   atdVariable: {
//       key: 'atdVariable',
//       type: 'text',
//       label: 'ATD Variable',
//       placeholder: '',
//       required: true,
//       requiredMessage: 'This field is required.',
//       minLength: 3,
//       minLengthMessage: 'Minimum 3 character allowed.',
//       maxLength: 100,
//       maxLengthMessage: 'maximum 100 character allowed.',
//       displayLayout: 'col-md-12',
//       tooltip: '<div> ATD Variable </div>',
//       pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
//       patternMessage: 'Variable Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-, space is not allowed'
//       // spaceNotAllowed: true

//   },
// };


// export const PrimaryFields = {
//   primaryValue: {
//       key: 'primaryValue',
//       type: 'text',
//       label: 'Primary Value',
//       placeholder: '',
//       required: true,
//       requiredMessage: 'This field is required.',
//       // minLength: 3,
//       // minLengthMessage: 'Minimum 3 charactors allowed.',
//       // maxLength: 100,
//       // maxLengthMessage: 'maximum 100 characters allowed.',
//       displayLayout: 'col-md-12',
//       tooltip: '<div> Primary Value </div>',
//       labelLayout: 'col-sm-12'
//       // pattern: /^(?=.*?[A-Za-z]).{1,}$/
//   },
//   // value: {
//   //     key: 'value',
//   //     type: 'text',
//   //     label: 'DSP Value',
//   //     placeholder: '',
//   //     required: true,
//   //     requiredMessage: 'This field is required.',
//   //     // minLength: 3,
//   //     // minLengthMessage: 'Minimum 3 charactors allowed.',
//   //     // maxLength: 100,
//   //     // maxLengthMessage: 'maximum 100 characters allowed.',
//   //     displayLayout: 'col-md-12',
//   //     tooltip: '<div> DSP Value </div>',
//   //     // pattern: /^(ftp|www|http|https)(:\/\/|.)[^ "]+$/,
//   //     // patternMessage: 'Invalid url'

//   //     // pattern: /^(?=.*?[A-Za-z]).{1,}$/
//   // },
// }

// export const SecondaryFields = {

//   secondaryValue: {
//       key: 'secondaryValue',
//       type: 'text',
//       label: 'Secondary Value',
//       placeholder: '',
//       required: false,
//       requiredMessage: 'This field is required.',
//       // minLength: 3,
//       // minLengthMessage: 'Minimum 3 charactors allowed.',
//       // maxLength: 100,
//       // maxLengthMessage: 'maximum 100 characters allowed.',
//       displayLayout: 'col-md-12',
//       tooltip: '<div> Primary Value </div>',
//       labelLayout: 'col-sm-12'
//       // pattern: /^(?=.*?[A-Za-z]).{1,}$/
//   },

// }

// export const confirmationMessage = {
//   action: {
//       confirmationMessage: 'Are You Sure To Save?',
//       type: 'Confirmation'
//   }
// }

// export const successfullyMessage = {
//   action: {
//       confirmationMessage: 'Successfully Saved Media Plan Details',
//       type: 'Success',
//   }
// }





export const formFields = {
  attributes: {
    key: 'attributes',
    type: 'text',
    label: 'Attributes',
    placeholder: 'Enter Attributes',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> DSP Name </div>',
    // pattern: /^[A-Za-z][A-Za-z0-9]*$/,
    patternMessage: 'Platform Name must start with a letter. Allowed characters are a-z & A-Z, 0-9, space is not allowed'
    // patternMessage: 'Space is not allowed', 
  },
  platform: {
    key: 'platform',
    label: 'Platform Name',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'key',
    textKey: 'value',
  },
  mappingVariable: {
    key: 'mappingVariable',
    label: 'Mapping Variable ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    labelLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
    addBreakOptional: false
  },
  primaryValue: {
    key: 'primaryValue',
    type: 'text',
    label: 'Value',
    placeholder: 'Enter Attributes',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 1,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> DSP Name </div>',
    // pattern: /^[A-Za-z][A-Za-z0-9]*$/,
    patternMessage: 'Platform Name must start with a letter. Allowed characters are a-z & A-Z, 0-9, space is not allowed',
    indexWithLabel: true
    // patternMessage: 'Space is not allowed', 
  },
  mappingValue: {
    key: 'mappingValue',
    label: 'Map with Beki Value',
    placeholder: '--Select--',
    labelLayout: 'col-12',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
    addBreakOptional: false
  },
  displayText: {
    key: 'displayText',
    label: 'Variable Display Text',
    placeholder: '',
    labelLayout: 'col-12',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    addBreakOptional: false,
  },
  valueDisplayText: {
    key: 'valueDisplayText',
    label: 'Value Display Text',
    placeholder: '',
    labelLayout: 'col-12',
    displayLayout: 'col-sm-12',
    required: false,
    requiredMessage: 'This field is required.',
    addBreakOptional: false,
    indexWithLabel: true
  }
};